import * as React from 'react';
import { styled } from '@mui/material/styles';
import { showApproveImagesBox } from '../../entry/state/utils';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { IImageThumbnail } from '../../../Entities';
import { IExtraImageCost } from '../../listImages/queries/use-query-images';
import ImagesApprovalBox from './ImagesApprovalBox';

const ApprovalContainer = styled('div')({
    display: 'flex',
    justifyContent: 'flex-end',
    '& > *': {
        width: '50%',
    },
});

type ApprovalSectionProps = {
    orderId: number;
    user: AuthenticatedUser;
    currentStatus: number;
    allImages: IImageThumbnail[];
    totalExtraImageCount: number;
    totalExtraImageCost: IExtraImageCost | null;
    totalDeliveredCount: number;
    getEffectiveCategory: (image: IImageThumbnail) => number;
    onApprovalStarted: () => void;
    onApprovalCompleted: () => void;
    onApprovalFailed: () => void;
};

export function ApprovalSection({
    orderId,
    user,
    currentStatus,
    allImages,
    totalExtraImageCount,
    totalExtraImageCost,
    totalDeliveredCount,
    getEffectiveCategory,
    onApprovalStarted,
    onApprovalCompleted,
    onApprovalFailed
}: ApprovalSectionProps) {
    if (!showApproveImagesBox(currentStatus, user)) {
        return null;
    }

    return (
        <ApprovalContainer>
            <ImagesApprovalBox
                orderId={orderId}
                images={allImages}
                extraImageCount={totalExtraImageCount}
                deliveredCount={totalDeliveredCount}
                extraImageCost={totalExtraImageCost}
                getEffectiveCategory={getEffectiveCategory}
                onApprovalStarted={onApprovalStarted}
                onApprovalCompleted={onApprovalCompleted}
                onApprovalFailed={onApprovalFailed}
            />
        </ApprovalContainer>
    );
}
